import React from "react";
import { Link } from "gatsby";

const MoneyBack = () => {
  return (
    <div className="px-8 md:px-0 mx-auto max-w-prose">
      <h1 className="text-gray text-35 md:text-50 my-10 text-center">
        Money Back Guarantee
      </h1>
      <p className="leading-loose mb-4">
        We strongly believe in our products and want every customer to leave
        satisfied.
        <br />
        We take what we make, so we’re confident they work. However, if the
        product doesn’t perform for you, we’re not going to play games with your
        hard-earned money. All we ask is you give it a fair go and take the
        recommended dosage for at least a few weeks.
      </p>
      <p className="leading-loose mb-8">
        To request a refund,{" "}
        <Link to="/contact" className="text-green underline">
          contact us here
        </Link>{" "}
        and tell us why it wasn’t a good fit.
      </p>
      <h2 className="text-gray text-25 my-4">Terms</h2>
      <p className="leading-loose pb-12">
        Our money-back guarantee is valid for first-time purchases of a formula
        and is redeemable for up to 60 days after the purchase date.
        <br />
        Refunds issued are for the purchase price of the product(s), excluding
        any shipping charges.
      </p>
    </div>
  );
};

export default MoneyBack;
